import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const HideIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M2.21065 4.38604C2.54972 3.9501 3.17799 3.87156 3.61394 4.21063L21.6139 18.2106C22.0499 18.5497 22.1284 19.178 21.7894 19.6139C21.4503 20.0499 20.822 20.1284 20.3861 19.7893L18.1549 18.054C16.6198 19.1994 14.5905 20 12 20C5.34904 20 2.57776 14.8021 2.0222 12.2095L1.9773 12L2.0222 11.7905C2.28387 10.5693 3.00705 8.84166 4.35427 7.32017L2.38606 5.78934C1.95011 5.45027 1.87158 4.82199 2.21065 4.38604ZM5.93699 8.55117C4.86916 9.7203 4.26972 11.0567 4.02719 12.0004C4.57137 14.1306 6.82592 18 12 18C13.8804 18 15.3543 17.4982 16.5008 16.7674L14.4433 15.1672C13.7679 15.6887 12.9199 16 12 16C9.79086 16 8 14.2091 8 12C8 11.436 8.11717 10.8984 8.3283 10.4111L5.93699 8.55117ZM10.0186 11.7257C10.0063 11.8153 10 11.9069 10 12C10 13.1046 10.8954 14 12 14C12.2669 14 12.5213 13.948 12.754 13.8533L10.0186 11.7257ZM12 5.99998C10.8274 5.99998 9.81935 6.19504 8.95467 6.51278C8.43628 6.70326 7.86162 6.43744 7.67113 5.91905C7.48064 5.40066 7.74646 4.82599 8.26485 4.6355C9.35849 4.23364 10.6007 3.99998 12 3.99998C18.651 3.99998 21.4222 9.19782 21.9778 11.7905L22.0227 12L21.9778 12.2095C21.8113 12.9863 21.4634 13.9476 20.9035 14.9243C20.6288 15.4034 20.0177 15.5691 19.5386 15.2945C19.0594 15.0198 18.8937 14.4087 19.1684 13.9296C19.5754 13.2196 19.8341 12.5386 19.9728 11.9995C19.4286 9.8693 17.174 5.99998 12 5.99998Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

HideIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(HideIcon);
